var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFBC5C",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFBC5C",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.874 21c.343 0 .622.299.622.667v21.447c0 .368-.279.667-.622.667H18.222c-.344 0-.622-.299-.622-.667V21.667c0-.368.278-.667.622-.667h18.652zm-4.877 6.122l-6.062 6.927-1.992-1.992a1.333 1.333 0 1 0-1.886 1.886l4.008 4.008 7.938-9.073a1.333 1.333 0 1 0-2.006-1.756zM45 37v3.697a1 1 0 0 1-.168.555L43 44l-1.832-2.748a1 1 0 0 1-.168-.555V26h4v11zm0-13h-4v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensive);
export default __webpack_public_path__ + "static/media/comprehensive.cfefeb8a527d741ed488b5ef106227dc.svg";
export { ForwardRef as ReactComponent };